import { BaseEmptyPrefixControlBehaviour } from './BaseControlBehaviour';
/**
 * ReplaceTag - заменяет у элемента таг на таг указанный в аттрибуте replacetag в качестве значения
 */
export class ReplaceTagBehaviour extends BaseEmptyPrefixControlBehaviour {
    constructor() {
        super('replacetag');
    }

    protected installBehaviour(element: HTMLElement): void {
        const tag = this.getBehaviorValue(element);
        const newTag = $('<' + tag + '>')[0];
        $.each(element.attributes, (i, value) => {
            newTag.setAttribute(element.attributes[i].name, value);
        });
        $(element).children().clone(true, true).appendTo(newTag);
        $(element).replaceWith(newTag);
    }
}

if(!window.Behaviours) window.Behaviours = {};
window.Behaviours.ReplaceTagBehaviour = ReplaceTagBehaviour;